import { useNavigate } from 'react-router-dom';
import { Button } from '@plush-book/ui';

export function Start() {
  const nav = useNavigate();
  return (
    <div className="shell paper" style={{ position: 'relative', overflow: 'hidden' }}>
      <div
        style={{
          position: 'absolute',
          top: 60,
          right: -40,
          width: 200,
          height: 200,
          borderRadius: '50%',
          background: 'radial-gradient(circle, #F8EBB7, #ECCF6E)',
          opacity: 0.5,
        }}
      />
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '30px 24px',
          maxWidth: 560,
          margin: '0 auto',
          width: '100%',
        }}
      >
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 16,
            background: 'var(--terracotta)',
            display: 'grid',
            placeItems: 'center',
            color: '#fff',
            fontFamily: 'var(--serif)',
            fontWeight: 600,
            fontSize: 28,
            marginBottom: 24,
          }}
        >
          k
        </div>
        <h1
          style={{
            fontFamily: 'var(--serif)',
            fontSize: 36,
            fontWeight: 500,
            lineHeight: 1.1,
            letterSpacing: -0.5,
            margin: 0,
          }}
        >
          Gestalte dein persönliches Kuscheltier&shy;buch.
        </h1>
        <p
          style={{
            fontSize: 16,
            lineHeight: 1.55,
            color: 'var(--ink-soft)',
            marginTop: 18,
          }}
        >
          In wenigen Minuten entsteht eine erste Vorschau mit deinem eigenen Kuscheltier.
        </p>
        <div style={{ marginTop: 28, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {['Keine Kinderfotos nötig', 'Vorschau vor dem Druck', '1 Korrekturrunde inklusive'].map(
            (t) => (
              <div
                key={t}
                style={{
                  display: 'flex',
                  gap: 10,
                  alignItems: 'center',
                  fontSize: 14,
                  color: 'var(--ink-soft)',
                }}
              >
                <span
                  style={{
                    width: 22,
                    height: 22,
                    borderRadius: 999,
                    background: 'var(--sage)',
                    display: 'grid',
                    placeItems: 'center',
                    color: '#fff',
                    fontSize: 11,
                  }}
                >
                  ✓
                </span>
                {t}
              </div>
            ),
          )}
        </div>
        <div style={{ marginTop: 36 }}>
          <Button variant="primary" size="lg" fullWidth onClick={() => nav('/story')}>
            Loslegen →
          </Button>
        </div>
      </div>
    </div>
  );
}
